




import { Component, Vue } from "vue-property-decorator";
import PpiRekapKepatuhan from "@/components/ppi/rekap/PpiRekapKepatuhan.vue";

@Component({
  components: { PpiRekapKepatuhan }
})
export default class PpiRekapSurveilansPage extends Vue {}
